import { Component, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { selectPagination } from '@results/store/results.selector';
import { selectContextLocale } from '@store/context/context.selector';
import { IHotelsAppState } from '@store/index';
import { selectRouterEntity } from '@store/router/router.selector';
import { getNested } from 'globals';
import { take } from 'rxjs/operators';
import { SearchWidgetComponent } from '../search-widget/search-widget.component';
import { TitleCasePipe } from '@angular/common';
@Component({
  selector: 'am-header-landing',
  standalone: true,
  styleUrls: ['./header-landing.component.scss'],
  templateUrl: './header-landing.component.html',
  imports: [SearchWidgetComponent, TitleCasePipe],
})
export class HeaderLandingComponent implements OnInit {
  public locale: string;
  public entity: any;
  public total: number;
  public seo: any;
  public background: string;
  public randomImage: string;
  public seoTitleFirstWord: string;
  public seoTitleRest: string;

  constructor(private store$: Store<IHotelsAppState>) {}

  public ngOnInit(): void {
    this.seo = getNested(window, '_app_context', 'seo', 'filter');
    this.initialize();
  }

  public initialize() {
    this.setRandomImage();
    this.setBackground();
    this.setTotal();
  }

  public setRandomImage() {
    this.store$.pipe(select(selectContextLocale), take(1)).subscribe(() => {
      this.randomImage = `/hotels/results/dist/es-AR/browser/assets/images/background-location/random-${Math.floor(
        Math.random() * 6 + 1,
      )}.jpg`;
    });

    this.store$.pipe(select(selectRouterEntity), take(1)).subscribe((entity: any) => {
      const nameArray = entity.name.split(' ');
      this.seoTitleFirstWord = nameArray.shift();
      this.seoTitleRest = nameArray.join(' ');
    });
  }

  public setBackground() {
    this.store$.pipe(select(selectRouterEntity), take(1)).subscribe((entity: any) => {
      this.entity = entity;
      this.background = entity.id
        ? `/hotels/results/dist/es-AR/browser/assets/images/background-location/${entity.id}.jpg`
        : this.randomImage;
    });
  }

  public setTotal() {
    this.store$.pipe(select(selectPagination)).subscribe((pagination: any) => {
      this.total = pagination.total;
    });
  }

  public getRandomImage(event) {
    event.target.src = this.randomImage;
  }
}
